import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Text } from '@beef/ui-kit';
import { Icon } from 'components';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const PROCESSING_SIGN = '**';

const ServiceLimit = ({
  balance, limit, unit, size = '3-m', isProcessing, unlimited,
}) => {
  const balanceToString = String(balance).replace('.', ',');
  const balanceValue = isProcessing ? PROCESSING_SIGN : balanceToString;
  const maxLimit = isProcessing ? PROCESSING_SIGN : limit;

  const infinityIcon = (<Icon name="infinity-dark" className={cn('infinity-icon')} />);

  const balanceBlock = (
    <div className={cn('block__values')}>
      <div className={cn('block__balance')}>
        <Text size={`size${size}`}>{balanceValue}</Text>
      </div>
      &nbsp;
      <div className={cn('block__divider')}>
        <div className={cn('block__divider--mobile')}>
          <Text color="grey50" size="size5-r-s">/</Text>
        </div>
        <div className={cn('block__divider--desktop')}>
          <Text color="grey50" size="size5-r-s">из</Text>
        </div>
      </div>
      &nbsp;
      <div className={cn('block__limit')}>
        <Text
          color="grey50"
          size="size5-r-s"
        >
          {maxLimit}
        </Text>
      </div>
    </div>
  );

  const currentBalance = unlimited && !isProcessing ? infinityIcon : balanceBlock;

  return (
    <div className={cn('block')}>
      {currentBalance}
      <div className={cn('block__unit')}>
        <Text
          size="size5-r-s"
        >
          {unit}
        </Text>
      </div>
    </div>
  );
};

ServiceLimit.propTypes = {
  balance: PropTypes.string,
  limit: PropTypes.string,
  unit: PropTypes.string,
  size: PropTypes.string,
  isProcessing: PropTypes.bool,
  unlimited: PropTypes.bool,
};

export { ServiceLimit };
